module.exports = __webpack_public_path__ + "static/communities-hero-mobile.4ca00da2.webp";